module.exports = __webpack_public_path__ + "img/andreea-cross-sale-cta.5d20ba85.png";